export const REQUEST_FOR_BALLOT = 'REQUEST_FOR_BALLOT';
export const BALLOT_REQUEST_SUCCESS = 'BALLOT_REQUEST_SUCCESS';
export const BALLOT_REQUEST_ERROR = 'BALLOT_REQUEST_ERROR';
export const SET_BALLOT_NOTICE_MODAL_STATE = 'SET_BALLOT_NOTICE_MODAL_STATE';
export const BALLOT_HIDE_ALERT = 'BALLOT_HIDE_ALERT';
